import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";

export const addEmployee = (data: any) => {
    return postApi(constants.urls.EMPLOYEE_ADD, data);
};

export const editEmployee = (data: any, id: string) => {
    return putApi(constants.urls.EMPLOYEE_EDIT + "/" + id, data);

};

export const employeeStatus = (id:any, flag:any) => {
  return putApi(constants.urls.EMPLOYEE_STATUS + "/" + id+"/"+flag, {});

};

export const getPatientlistcount = () => {
  return getApi(constants.urls.PATIENT_COUNT);
};

export const listEmployee = (params: string = "") => {
    return getApi(constants.urls.EMPLOYEE_LIST, params);

};
export const deleteEmployee = (id: string) => {
    return deleteApi(constants.urls.EMPLOYEE_DELETE + "/" + id+"?hard=true");
};


export const getByEmployeeId = (id: string) => {
    return getApi(constants.urls.EMPLOYEE_GETBYID + "/" + id);
};

export const rollbackEmployee = (id: string) => {
  return deleteApi(constants.urls.EMPLOYEE_DROPDOWN + "/" + id);
};

export const employeeDropdown = () => {
  return getApi(constants.urls.EMPLOYEE_DROPDOWN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

export const employeeDropdownHandyman = () => {
  return getApi(constants.urls.EMPLOYEE_DROPDOWN_HANDYMAN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

 export const getstatus = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:0,
            label:"Inactive"
          },
          {
            id:1,
            label:"Active"
          }
        ])
      })
    })
  }

  export const getRole = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:1,
            label:"Admin"
          },
          {
            id:2,
            label:"User"
          },
        ])
      })
    })
  }